module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-alert', {
    staticClass: "err",
    attrs: {
      "color": "error",
      "value": true,
      "icon": "warning",
      "type": "error"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.err) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.errors.length > 0) ? _c('v-alert', {
    staticClass: "err",
    attrs: {
      "color": "error",
      "value": true,
      "icon": "warning",
      "type": "error"
    }
  }, _vm._l((_vm.errors), function(err) {
    return _c('span', [_vm._v(_vm._s(err.message) + "."), _c('br')])
  }), 0) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.success) ? _c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v("\n          " + _vm._s(_vm.success) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), ((this.$route.query.id) && !_vm.loaded) ? _c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _c('div', [(!_vm.isLocalAdmin) ? [_c('h2', [_vm._v(_vm._s(_vm.$lang.labels.company))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.companies.length > 0) ? _c('v-flex', {
    staticClass: "text-xs-center",
    staticStyle: {
      "z-index": "5"
    },
    attrs: {
      "grow": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-0 ",
    class: {
      'v-btn--disabled': _vm.$route.query.id && !_vm.currentCorporation
    },
    attrs: {
      "flat": "",
      "block": "",
      "disabled": !!_vm.$route.query.id && !_vm.currentCorporation,
      "outline": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.selectedCompany ? _vm.selectedCompany.name : _vm.$lang.labels.selectCompany) + "\n              ")]), _vm._v(" "), _c('v-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticStyle: {
      "box-shadow": "0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)",
      "margin-top": "-6px"
    }
  }, [_c('v-list-tile', {
    staticClass: "search pt-0",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$lang.labels.filterCategories
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.filteredCompanies), function(company) {
    return (!_vm.selectedCompany || _vm.selectedCompany.id !== company.id) ? _c('v-list-tile', {
      key: company.id,
      on: {
        "click": function($event) {
          return _vm.selectCompany(company)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(company.name) + " (" + _vm._s(company.companyStatus) + ")")])], 1) : _vm._e()
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$lang.actions.changeCompany) + "\n            ")])], 1)] : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "my-4",
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('h2', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.catalogName))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": _vm.$lang.labels.name1,
      "type": "text"
    },
    on: {
      "blur": function($event) {
        _vm.name = _vm.name.trim()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), (_vm.version) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pl-4": ""
    }
  }, [_c('h2', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.originalVersion))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0"
  }, [_vm._v(_vm._s(_vm.version))])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "d-inline-flex",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.copyWholeCatalog()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$lang.actions.copyCatalog) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.turnOnPasteListen()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isPasteOn ? _vm.$lang.actions.pasteCatalogTurnOff : _vm.$lang.actions.pasteCatalogTurnOn) + "\n            ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "my-4",
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('div', {
    staticClass: "d-inline-flex"
  }, [_c('h2', {
    staticClass: "mr-3 pt-1 mt-2"
  }, [_vm._v(_vm._s(_vm.$lang.header.views))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editViews = true;
        _vm.currentView = null
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.predefinedViewsModal = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.predefinedViews) + "\n          ")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "views pa-3",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": _vm.editViewToggle
    }
  }, [(_vm.views.length === 0) ? _c('p', {
    staticClass: "m-0"
  }, [_vm._v(_vm._s(_vm.$lang.actions.addViews))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.views), function(view, index) {
    return _c('div', {
      key: index,
      staticClass: "py-1 px-3 ma-0 my-1 mr-2 views--item"
    }, [_vm._v("\n            " + _vm._s(view.name[_vm.language]) + "\n            "), (typeof view.viewId !== 'undefined') ? _c('small', [_vm._v("(" + _vm._s(view.viewId) + ")")]) : _vm._e(), _vm._v(" "), (view.isDefault) ? _c('small', {
      domProps: {
        "textContent": _vm._s('<Default>')
      }
    }) : _vm._e(), _vm._v(" "), _c('v-icon', {
      staticClass: "ml-2",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editView(view, index)
        }
      }
    }, [_vm._v("edit")]), _vm._v(" "), _c('v-icon', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteView(view.viewId)
        }
      }
    }, [_vm._v("delete")])], 1)
  })], 2), _vm._v(" "), _c('v-layout', {
    staticClass: "my-4",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('h2', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.allergens))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editAllergens = true;
        _vm.currentAllergen = null
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "views pa-3",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": _vm.editAllergenToggle
    }
  }, [(_vm.allergens.length === 0) ? _c('p', {
    staticClass: "m-0"
  }, [_vm._v("Click to add allergens")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.allergens), function(allergen, index) {
    return _c('div', {
      key: index,
      staticClass: "py-1 px-3 ma-0 my-1 mr-2 views--item"
    }, [_vm._v("\n            " + _vm._s(allergen.name[_vm.language]) + "\n            "), (typeof allergen.allergenId !== 'undefined') ? _c('small', [_vm._v("(" + _vm._s(allergen.allergenId) + ")")]) : _vm._e(), _vm._v(" "), _c('v-icon', {
      staticClass: "ml-2",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editAllergen(allergen, index)
        }
      }
    }, [_vm._v("edit")]), _vm._v(" "), _c('v-icon', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteAllergen(allergen.allergenId)
        }
      }
    }, [_vm._v("delete")])], 1)
  })], 2), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4 mb-2",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('h2', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.massAddRemove))])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.massAddViews = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addViews1))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.massAddAllergens = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addAllergens))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.massAddPrinters = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addPrinters))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.massRemovePrinters = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.removePrinters))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.selectedCompany || !_vm.selectedCompanyInfo.vatRates || _vm.selectedCompanyInfo.vatRates.length === 0
    },
    on: {
      "click": function($event) {
        _vm.vatModal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addVAT))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.massLangModal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.translate))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.exportCsv()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.exportCSV))])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "my-4",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('h2', {
    staticClass: "d-inline-block m-0"
  }, [_vm._v(_vm._s(_vm.$lang.header.items))]), _vm._v(" "), _c('v-btn', {
    staticClass: "item-actions d-inline-block",
    attrs: {
      "fab": "",
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.actionPath = null;
        _vm.itemModal = true;
        _vm.currentItemEvent = 'add'
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "show-buttons",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.openAll(_vm.items, true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.showAllChildren))]), _vm._v(" "), _c('v-btn', {
    staticClass: "show-buttons",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.openAll(_vm.items, false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.hideAllChildren))])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "my-4",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [(!_vm.notLoading) ? _c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.notLoading) ? _c('ul', _vm._l((_vm.filtereditems), function(item, index) {
    return _c('item', {
      key: index,
      attrs: {
        "index": index,
        "items": _vm.filtereditems,
        "views": _vm.views,
        "isEdit": _vm.isEdit,
        "itemData": item
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
        },
        "selected": _vm.select,
        "setMaxItemId": _vm.setMaxItemId,
        "deleted": _vm.deleteItem,
        "copyItem": _vm.copyItem,
        "massAdd": _vm.massAddShow,
        "massRemove": _vm.massRemoveShow,
        "addItem": _vm.addItemEvent,
        "editItem": _vm.editItemEvent
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.err || _vm.errors.length > 0 || _vm.success) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.err) ? _c('v-alert', {
    staticClass: "err",
    attrs: {
      "color": "error",
      "value": true,
      "icon": "warning",
      "type": "error"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.err) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.errors.length > 0) ? _c('v-alert', {
    staticClass: "err",
    attrs: {
      "color": "error",
      "value": true,
      "icon": "warning",
      "type": "error"
    }
  }, _vm._l((_vm.errors), function(err) {
    return _c('span', [_vm._v(_vm._s(err.message) + "."), _c('br')])
  }), 0) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.success) ? _c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v("\n              " + _vm._s(_vm.success) + "\n            ")]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('router-link', {
    staticClass: "mx-0 v-btn--flat",
    attrs: {
      "tag": "v-btn",
      "to": {
        path: 'list'
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_left")]), _vm._v("\n            cancel\n          ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.creating
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.createCatalog($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.create))])], 1)], 2)], 1)], 1), _vm._v(" "), (_vm.itemModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1600px"
    },
    model: {
      value: (_vm.itemModal),
      callback: function($$v) {
        _vm.itemModal = $$v
      },
      expression: "itemModal"
    }
  }, [_c('item-modal', {
    attrs: {
      "plusOne": _vm.plusOne,
      "currentItemEvent": _vm.currentItemEvent,
      "copyData": _vm.copyItemData ? _vm.copyItemData : null,
      "taxCategories": _vm.taxCategories,
      "editItem": _vm.editItem,
      "actionPath": _vm.actionPath,
      "selectedCompanyInfo": _vm.selectedCompanyInfo,
      "views": _vm.views,
      "allergens": _vm.allergens,
      "maxItemId": _vm.maxItemId,
      "items": _vm.items
    },
    on: {
      "copy": function($event) {
        return _vm.copy($event)
      },
      "submit": _vm.addItem,
      "close": function($event) {
        _vm.itemModal = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.vatModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200px"
    },
    model: {
      value: (_vm.vatModal),
      callback: function($$v) {
        _vm.vatModal = $$v
      },
      expression: "vatModal"
    }
  }, [_c('vat-modal', {
    attrs: {
      "selectedCompanyInfo": _vm.selectedCompanyInfo
    },
    on: {
      "submit": _vm.addVATToItems,
      "close": function($event) {
        _vm.vatModal = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massAddViews) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200px"
    },
    model: {
      value: (_vm.massAddViews),
      callback: function($$v) {
        _vm.massAddViews = $$v
      },
      expression: "massAddViews"
    }
  }, [_c('views-modal', {
    attrs: {
      "views": _vm.views
    },
    on: {
      "submit": _vm.addViewsToItems,
      "close": function($event) {
        _vm.massAddViews = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massAddAllergens) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200px"
    },
    model: {
      value: (_vm.massAddAllergens),
      callback: function($$v) {
        _vm.massAddAllergens = $$v
      },
      expression: "massAddAllergens"
    }
  }, [_c('allergens-modal', {
    attrs: {
      "allergens": _vm.allergens
    },
    on: {
      "submit": _vm.addAllergensToItems,
      "close": function($event) {
        _vm.massAddAllergens = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massAddPrinters) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.massAddPrinters),
      callback: function($$v) {
        _vm.massAddPrinters = $$v
      },
      expression: "massAddPrinters"
    }
  }, [_c('printers-modal', {
    on: {
      "submit": _vm.addPrintersToItems,
      "close": function($event) {
        _vm.massAddPrinters = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massRemovePrinters) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200px"
    },
    model: {
      value: (_vm.massRemovePrinters),
      callback: function($$v) {
        _vm.massRemovePrinters = $$v
      },
      expression: "massRemovePrinters"
    }
  }, [_c('printers-modal', {
    attrs: {
      "remove": true
    },
    on: {
      "submit": _vm.removePrintersFromItems,
      "close": function($event) {
        _vm.massRemovePrinters = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massLangModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "800px"
    },
    model: {
      value: (_vm.massLangModal),
      callback: function($$v) {
        _vm.massLangModal = $$v
      },
      expression: "massLangModal"
    }
  }, [_c('lang-trans-modal', {
    on: {
      "submit": function($event) {
        return _vm.massTranslate($event)
      },
      "close": function($event) {
        _vm.massLangModal = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editViews) ? _c('v-dialog', {
    attrs: {
      "max-width": "700px"
    },
    model: {
      value: (_vm.editViews),
      callback: function($$v) {
        _vm.editViews = $$v
      },
      expression: "editViews"
    }
  }, [_c('view-modal', {
    attrs: {
      "edit": _vm.currentView,
      "orderTypes": _vm.orderTypes,
      "selectedOrderTypes": _vm.selectedOrderTypes,
      "maxViewId": _vm.maxViewId
    },
    on: {
      "submit": _vm.addView,
      "update": _vm.editViewSubmit,
      "changeSelectedOrderTypes": _vm.changeSelectedOrderTypes,
      "close": function($event) {
        _vm.editViews = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editAllergens) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200px"
    },
    model: {
      value: (_vm.editAllergens),
      callback: function($$v) {
        _vm.editAllergens = $$v
      },
      expression: "editAllergens"
    }
  }, [_c('allergen-modal', {
    attrs: {
      "edit": _vm.currentAllergen,
      "maxAllergenId": _vm.maxAllergenId
    },
    on: {
      "submit": _vm.addAllergen,
      "update": _vm.editAllergenSubmit,
      "close": function($event) {
        _vm.editAllergens = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showActivationModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.showActivationModal),
      callback: function($$v) {
        _vm.showActivationModal = $$v
      },
      expression: "showActivationModal"
    }
  }, [_c('activation-modal', {
    attrs: {
      "data": _vm.activationData
    },
    on: {
      "close": function($event) {
        return _vm.closeActivation()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massRemoveViews) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.massRemoveViews),
      callback: function($$v) {
        _vm.massRemoveViews = $$v
      },
      expression: "massRemoveViews"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "text": _vm.$lang.labels.massRemoveViews
    },
    on: {
      "submit": function($event) {
        return _vm.removeViewFromItems()
      },
      "close": function($event) {
        _vm.massRemoveViews = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massRemoveAllergens) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.massRemoveAllergens),
      callback: function($$v) {
        _vm.massRemoveAllergens = $$v
      },
      expression: "massRemoveAllergens"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "text": _vm.$lang.labels.massRemoveAllergens
    },
    on: {
      "submit": function($event) {
        return _vm.removeAllergenFromItems()
      },
      "close": function($event) {
        _vm.massRemoveAllergens = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.massAddModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800"
    },
    model: {
      value: (_vm.massAddModal),
      callback: function($$v) {
        _vm.massAddModal = $$v
      },
      expression: "massAddModal"
    }
  }, [_c('mass-add-modal', {
    attrs: {
      "catalog": _vm.items,
      "data": _vm.massAddData,
      "views": _vm.views,
      "taxCategories": _vm.taxCategories,
      "selectedCompanyInfo": _vm.selectedCompanyInfo
    },
    on: {
      "submit": function($event) {
        return _vm.massAdd($event)
      },
      "close": function($event) {
        _vm.massAddModal = false
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.massRemoveModalTree) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800"
    },
    model: {
      value: (_vm.massRemoveModalTree),
      callback: function($$v) {
        _vm.massRemoveModalTree = $$v
      },
      expression: "massRemoveModalTree"
    }
  }, [_c('mass-remove-modal', {
    attrs: {
      "data": _vm.massRemoveDataTree,
      "viewsTree": _vm.viewsTree,
      "printCategoriesTree": _vm.printCategoriesTree,
      "views": _vm.views,
      "taxCategories": _vm.taxCategories,
      "selectedCompanyInfo": _vm.selectedCompanyInfo
    },
    on: {
      "submit": function($event) {
        return _vm.massRemove($event)
      },
      "close": function($event) {
        _vm.massRemoveModalTree = false
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.predefinedViewsModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    model: {
      value: (_vm.predefinedViewsModal),
      callback: function($$v) {
        _vm.predefinedViewsModal = $$v
      },
      expression: "predefinedViewsModal"
    }
  }, [_c('add-predefined-views', {
    attrs: {
      "filteredViews": _vm.filteredViews
    },
    on: {
      "submit": function($event) {
        return _vm.addPredefinedView($event)
      },
      "close": function($event) {
        _vm.predefinedViewsModal = false
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aef5966","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalog/Single.vue
// module id = 412
// module chunks = 35